import { render, staticRenderFns } from "./FormGenerateNomina.vue?vue&type=template&id=18100685&"
import script from "./FormGenerateNomina.vue?vue&type=script&lang=js&"
export * from "./FormGenerateNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports